import environment from "@menu-environment";
import imageSrc from "@menu/core/lib/image-src";
import MenuContext from "@menu/core/menu.context";
import { observer } from "mobx-react-lite"

type CountryFlagIconProps = {
    countryCode: string,
    onClick: (e: any) => void,
    context: MenuContext
}

const CountryFlagIcon = observer((props: CountryFlagIconProps) => {
    const { countryCode, context, onClick } = props;
    const flagImage = context.country?.flagImage;

    if (!flagImage) {
        const cssClassName = `flag flag-${countryCode}`;

        return <i className={cssClassName} onClick={onClick} />;
    }

    const src = imageSrc(flagImage);

    return <img className="flag" src={src} onClick={onClick} />
});

export default CountryFlagIcon;